module.exports = __webpack_public_path__ + "img/e.de3926f5.jpg";